<div class="sidebar">
  <div class="top">
    <div
      data-cy="sidebar-recents-button"
      class="tab"
      style="padding: 12px 24px"
      [ngClass]="{
        link_active: isActiveLink('/home'),
      }"
      (click)="goToHomePage()">
      <mat-icon svgIcon="recents" data-cy="sidebar-recents-icon" />
      <span class="link-title">{{ 'sidebar.menu.recents.label' | translate }}</span>
    </div>
    <div class="builder-container">
      <div class="search-shipyard-container">
        <app-channel-text-input
          class="input-search"
          data-cy="sidebar-search"
          [value]="searchInput"
          [label]="'sidebar.menu.search-input.placeholder'"
          (onInputChange)="searchInput = $event.value; filterShipyards()"
          [dark]="true"
          [icon]="'search'">
        </app-channel-text-input>
        <div class="radio-button-container" data-cy="sidebar-search-your-vessel-radio-container">
          <div
            class="border-radio-button"
            (click)="handleRadioButtonChange($event)"
            [ngClass]="{ selected: showVesselOwnerOnly }">
            <input
              class="radio-button"
              data-cy="sidebar-search-your-vessel-radio-button"
              type="radio"
              [value]="showVesselOwnerOnly"
              [checked]="showVesselOwnerOnly" />
          </div>

          {{ 'sidebar.menu.radio-button.label' | translate }}
        </div>
      </div>
      <div class="shipyard-list" data-cy="sidebar-shipyard-list" #shipyardListElem>
        <div *ngFor="let shipyard of filteredShipyardList">
          <div
            class="tab builder"
            data-cy="sidebar-shipyard-list-item"
            (click)="selectShipyard(shipyard.id)"
            [ngClass]="{
              link_active: selectedShipyardId === shipyard.id && !selectedVesselId,
            }">
            <div class="builder-title" [title]="shipyard.name">
              <ng-container
                *ngTemplateOutlet="
                  nameTemplate;
                  context: {
                    name: truncateName(shipyard.name),
                  }
                ">
              </ng-container>
            </div>
            <mat-icon
              svgIcon="arrow-down"
              [ngStyle]="{
                transform:
                  selectedShipyardId === shipyard.id && showShipyardVessels ? 'rotate(180deg)' : '',
              }" />
          </div>
          <div
            class="vessel-container"
            data-cy="sidebar-vessel-list"
            *ngIf="selectedShipyardId === shipyard.id && showShipyardVessels">
            <ng-container *ngTemplateOutlet="vesselsList; context: { vessels: shipyard.vessels }">
            </ng-container>
          </div>
        </div>
        <div *ngIf="filteredVesselsList.length > 0" class="filtered-vessels-title">
          {{ 'sidebar.menu.filtered-vessels.title' | translate: { searchInput } }}
        </div>
        <ng-container *ngTemplateOutlet="vesselsList; context: { vessels: filteredVesselsList }">
        </ng-container>
      </div>
    </div>
  </div>
  <div class="bottom">
    <div class="tab" data-cy="sidebar-drafts-button">
      <mat-icon svgIcon="file" data-cy="sidebar-drafts-icon" />
      <span class="link-title">{{ 'sidebar.menu.drafts.label' | translate }}</span>
    </div>
    <ng-container *ngIf="!isRunningInElectron">
      <div
        class="tab"
        data-cy="sidebar-device-management-button"
        [class.link_active]="isActiveLink('home/device-managment')"
        (click)="goToDeviceManagmentPage()">
        <mat-icon svgIcon="devices" data-cy="sidebar-device-management-icon" />
        <span class="link-title">
          {{ 'sidebar.menu.device-managment.label' | translate }}
        </span>
      </div>
    </ng-container>

    <div
      class="tab"
      data-cy="sidebar-communication-protocols-button"
      [class.link_active]="isActiveLink('home/communication-protocols')"
      (click)="goToProtocolsPage()">
      <mat-icon svgIcon="network-settings" data-cy="sidebar-communication-protocols-icon" />
      <span class="link-title">
        {{ 'sidebar.menu.communication-protocols.label' | translate }}
      </span>
    </div>

    <div
      class="tab"
      data-cy="sidebar-settings-button"
      [class.link_active]="isActiveLink('/home/settings')"
      (click)="goToSettingsPage()">
      <mat-icon svgIcon="settings" data-cy="sidebar-settings-icon" />
      <span class="link-title">{{ 'sidebar.menu.settings.label' | translate }}</span>
    </div>
    <div class="user-container">
      <img src="{{ profilePicture }}" class="profile-picture-icon" data-cy="sidebar-account-pic" />

      <div class="user-info">
        <div class="ellipsis" data-cy="sidebar-account-name">
          {{ currentUser?.name }}
        </div>
        <div class="user-email ellipsis" data-cy="sidebar-account-id">
          {{ currentUser?.email }}
        </div>
      </div>
      <mat-icon
        svgIcon="logout"
        class="logout-icon"
        data-cy="sidebar-logout-icon"
        (click)="logout()" />
    </div>
  </div>
</div>

<ng-template #vesselsList let-vessels="vessels">
  <div
    *ngFor="let vessel of vessels"
    class="tab vessel"
    data-cy="sidebar-vessel-list-item"
    (click)="selectVessel(vessel.shipyardId, vessel.id)"
    [ngClass]="{
      link_active: selectedShipyardId === vessel.shipyardId && selectedVesselId === vessel.id,
      pending: getIcon(vessel) === 'pending-approval',
      approved: getIcon(vessel) === 'spaceship',
    }">
    <div
      class="vessel-title"
      [attr.custom-attr]="getVesselName(vessel)"
      [style.--tooltip-margin-top]="toolTipMargin">
      <mat-icon svgIcon="vessel-folder" />
      <ng-container *ngTemplateOutlet="nameTemplate; context: { name: getVesselName(vessel) }">
      </ng-container>
    </div>
    <div class="vessel-icon-row">
      <div *ngIf="getIcon(vessel) === 'lock-profile'">
        {{ getActiveEditors(vessel) }}
      </div>
      <mat-icon data-cy="sidebar-vessel-icon" *ngIf="getIcon(vessel)" [svgIcon]="getIcon(vessel)" />
    </div>
  </div>
</ng-template>

<ng-template #nameTemplate let-name="name">
  <p class="name-container">
    <span
      *ngFor="let namePart of getNameArray(name)"
      class="name-class"
      [ngClass]="{
        highlighted: namePart.toLowerCase() === searchInput?.toLowerCase(),
      }">
      {{ namePart }}
    </span>
  </p>
</ng-template>
